import Button from '@mui/material/Button';
import React, { useContext, useEffect } from 'react';
import OrderFunctions from '../../../../MyFunctions/OrderFunctions';
import MyDateTime from '../../../MySections/TimeSections/MyDateTime';
import OrderStatuselect from './OrderStatuselect';
import { UserContext } from '../../../MyContexts/Users_Context';

const ListOrdersBlocks = (props) => {
    const [user, setUser] = useContext(UserContext);


    useEffect(() => {

    }, [])

    const orderBythis = (byWhat, ordUserOrBuiss) => {
        props.orderBythis(byWhat, ordUserOrBuiss);
    }
    const rowCellClick = (ordId) => {
        props.rowCellClick(ordId);
    }

    const setNewStatus = (orderId, statBack, buisId) => {
        props.setNewStatus(orderId, statBack, buisId);
    }

    return (
        <div className="table-responsive theBigTbl ms-panel-body">

            {
                props.theList.reverse().map((item, i) => {
                    let showme = (item.paymentStatus !== "ממתין לחיוב") ?
                        true :
                        (user.permiss === "admin") ? true : false;
                    return (

                        <div key={item._id} className={`${showme ? "" : "hideMe"} orderItminList regular pointing ${item.paymentStatus === "ממתין לחיוב" ? "tempoOrdRow" : ""}`}
                            itmid={item._id} id={item.orderNUM}>

                            <div className={"timerTd"} onClick={() => rowCellClick(item._id)} id={i + "_Count"}>
                                <div id={i + "_Cnt"}>
                                    <br />
                                </div>
                            </div>
                            <div className={'orderItmFlo onLeft'}>
                                <div className={"textLeft regular spaceTop spaceLeft"}>#{item.orderNUM}</div>
                                <div className={"textLeft regular spaceTop spaceLeft"}>הוזמן ב: {MyDateTime.getShortTime(item.dateCreated)}</div>
                                <Button className={`btnMediumMnu theSBtn onLeft spaceLeft`} variant="contained"
                                    onClick={() => rowCellClick(item._id)}>
                                    הצג הזמנה
                                </Button>
                            </div>

                            <div className={'orderItmblkIN'}>

                                <div className={"fullRow"}>
                                    <span className={"orderItmTxt veryBig bold"}>{(item.OrderType == "Take") ? "איסוף" : "משלוח"}</span>
                                </div>

                                <div className={"fullRow spaceTop"}>
                                    <span className={"orderItmTxt smallFont"}>הלקוח:</span>&nbsp;
                                    <span className={"orderItmTxt regular"}>{item.user.firstName} {item.user.lastName}</span>
                                </div>
                                <div className={"fullRow spaceTop"}>
                                    <span className={"orderItmTxt smallFont"}>טלפון:</span>&nbsp;
                                    <span className={"orderItmTxt regular"}>{item.user.phone}</span>
                                </div>
                                <div className={"fullRow spaceTop"}>
                                    <span className={"orderItmTxt smallFont"}>מסירה ב:</span>&nbsp;
                                    <span className={"orderItmTxt regular"}>{MyDateTime.getDateAndTime(item.dateToDeliver)}</span>
                                </div>
                                <div className={"fullRow spaceTop"}>
                                    {(item.OrderType == "Deliver") ?
                                        <>
                                            <br />
                                            <span className={"orderItmTxt smallFont"}>היעד:</span>&nbsp;
                                            <span className={"orderItmTxt regular"}>
                                                {item.deliveryAddress.street} {item.deliveryAddress.num}
                                            </span>
                                        </>

                                        : ""}
                                </div>
                                <div className={"fullRow"}>

                                    <div className={"statusCell pointing"} >
                                        <OrderStatuselect orderStatus={item.orderStatus}
                                            setOrderStatus={(statBack) => setNewStatus(item._id, statBack, item.buiss._id)}
                                        />

                                    </div>

                                </div>
                                <div className={"fullRow"}>
                                    <div className={"orderItmTxt textLeft big bold"}>לתשלום: ₪{item.totalPrice}</div>
                                </div>

                            </div>
                        </div>
                    )
                })
            }

        </div>
    )
}

export default ListOrdersBlocks;